/* Bravo Empire — theme.js (vanilla JS, no dependencies) */
(function () {
  "use strict";

  document.documentElement.classList.remove("no-js");
  var body = document.body;
  if (body.dataset.animations !== "false") body.classList.add("animations-enabled");
  if (body.dataset.hoverZoom !== "false") body.classList.add("hover-zoom-enabled");

  /* ---------------- Utilities ---------------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function trapFocus(container) {
    var focusable = qsa('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])', container);
    if (!focusable.length) return;
    focusable[0].focus();
  }
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    return (format || "${{amount}}").replace("{{amount}}", value);
  }
  window.BravoEmpire = window.BravoEmpire || {};
  window.BravoEmpire.formatMoney = formatMoney;

  /* ---------------- Scroll reveal ---------------- */
  if ("IntersectionObserver" in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view");
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    document.addEventListener("DOMContentLoaded", function () {
      qsa("[data-animate]").forEach(function (el) { revealObserver.observe(el); });
    });
  }

  /* ---------------- Sticky / transparent header ---------------- */
  var header = qs(".site-header");
  if (header) {
    var toggleScrolled = function () {
      if (window.scrollY > 40) header.classList.add("is-scrolled");
      else header.classList.remove("is-scrolled");
    };
    toggleScrolled();
    window.addEventListener("scroll", toggleScrolled, { passive: true });
  }

  /* ---------------- Mega menu (desktop hover / click) ---------------- */
  qsa(".header-nav__item").forEach(function (item) {
    var trigger = qs(".header-nav__link", item);
    var menu = qs(".mega-menu", item);
    if (!menu || !trigger) return;
    var open = function () { item.classList.add("is-open"); };
    var close = function () { item.classList.remove("is-open"); };
    item.addEventListener("mouseenter", open);
    item.addEventListener("mouseleave", close);
    trigger.addEventListener("click", function (e) {
      if (menu) {
        e.preventDefault();
        item.classList.toggle("is-open");
      }
    });
    trigger.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
  });
  document.addEventListener("click", function (e) {
    qsa(".header-nav__item.is-open").forEach(function (item) {
      if (!item.contains(e.target)) item.classList.remove("is-open");
    });
  });

  /* ---------------- Mobile nav ---------------- */
  var mobileNav = qs(".mobile-nav");
  var mobileToggle = qs(".header-mobile-toggle");
  if (mobileNav && mobileToggle) {
    var openMobile = function () { mobileNav.classList.add("is-open"); body.style.overflow = "hidden"; };
    var closeMobile = function () { mobileNav.classList.remove("is-open"); body.style.overflow = ""; };
    mobileToggle.addEventListener("click", openMobile);
    qsa("[data-mobile-nav-close]", mobileNav).forEach(function (btn) { btn.addEventListener("click", closeMobile); });
    qs(".mobile-nav__overlay", mobileNav).addEventListener("click", closeMobile);
    qsa(".mobile-nav__item [data-submenu-toggle]", mobileNav).forEach(function (btn) {
      btn.addEventListener("click", function () {
        btn.closest(".mobile-nav__item").classList.toggle("is-open");
      });
    });
  }

  /* ---------------- Generic modal/drawer open/close via data attrs ---------------- */
  function bindDrawer(triggerSelector, drawer, closeSelector) {
    qsa(triggerSelector).forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        drawer.classList.add("is-open");
        body.style.overflow = "hidden";
        trapFocus(drawer);
      });
    });
    if (!drawer) return;
    qsa(closeSelector, drawer).forEach(function (btn) {
      btn.addEventListener("click", function () {
        drawer.classList.remove("is-open");
        body.style.overflow = "";
      });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { drawer.classList.remove("is-open"); body.style.overflow = ""; }
    });
  }

  var cartDrawer = qs(".cart-drawer");
  if (cartDrawer) bindDrawer("[data-open-cart]", cartDrawer, "[data-close-cart],.cart-drawer__overlay");

  var searchDrawer = qs(".search-drawer");
  if (searchDrawer) {
    bindDrawer("[data-open-search]", searchDrawer, "[data-close-search],.search-drawer__overlay");
    var searchInput = qs("input[type='search']", searchDrawer);
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-open-search]") && searchInput) setTimeout(function () { searchInput.focus(); }, 50);
    });
  }

  var sizeGuideModal = qs(".size-guide-modal");
  if (sizeGuideModal) bindDrawer("[data-open-size-guide]", sizeGuideModal, "[data-close-size-guide],.modal__overlay");

  /* ---------------- Mobile filters toggle (collection page) ---------------- */
  var facetsAside = qs(".facets");
  var filtersToggle = qs("[data-open-filters]");
  if (facetsAside && filtersToggle) {
    filtersToggle.addEventListener("click", function () {
      facetsAside.classList.toggle("is-open-mobile");
      facetsAside.style.display = facetsAside.classList.contains("is-open-mobile") ? "block" : "";
    });
  }

  /* ---------------- Cart: fetch + render ---------------- */
  var CartAPI = {
    get: function () {
      return fetch("/cart.js").then(function (r) { return r.json(); });
    },
    add: function (formData) {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      });
    },
    change: function (line, quantity) {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) { return r.json(); });
    },
    updateNote: function (note) {
      return fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ note: note })
      }).then(function (r) { return r.json(); });
    }
  };
  window.BravoEmpire.CartAPI = CartAPI;

  function refreshCartDrawer() {
    fetch("/?section_id=cart-drawer")
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var newDrawer = doc.querySelector(".cart-drawer");
        var root = document.getElementById("cart-drawer-root");
        if (newDrawer && root) {
          var wasOpen = qs(".cart-drawer") && qs(".cart-drawer").classList.contains("is-open");
          root.innerHTML = "";
          root.appendChild(newDrawer);
          if (wasOpen) newDrawer.classList.add("is-open");
          bindCartDrawerEvents();
        }
        updateCartCount();
      });
  }

  function updateCartCount() {
    CartAPI.get().then(function (cart) {
      qsa("[data-cart-count]").forEach(function (el) { el.textContent = cart.item_count; });
      qsa("[data-cart-count-wrapper]").forEach(function (el) { el.hidden = cart.item_count === 0; });
    });
  }
  updateCartCount();

  function bindCartDrawerEvents() {
    var drawer = qs(".cart-drawer");
    if (!drawer) return;
    qsa("[data-close-cart],.cart-drawer__overlay", drawer).forEach(function (btn) {
      btn.addEventListener("click", function () { drawer.classList.remove("is-open"); body.style.overflow = ""; });
    });
    qsa("[data-qty-change]", drawer).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var line = parseInt(btn.dataset.line, 10);
        var qty = parseInt(btn.dataset.qtyChange, 10);
        var input = qs('[data-qty-input="' + line + '"]', drawer);
        var newQty = Math.max(0, parseInt(input.value, 10) + qty);
        input.value = newQty;
        CartAPI.change(line, newQty).then(refreshCartDrawer);
      });
    });
    qsa("[data-remove-line]", drawer).forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        CartAPI.change(parseInt(btn.dataset.removeLine, 10), 0).then(refreshCartDrawer);
      });
    });
  }
  bindCartDrawerEvents();

  /* ---------------- Add to cart forms (product page + quick add) ---------------- */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form.matches("[data-product-form]")) return;
    e.preventDefault();
    var submitBtn = qs("[type=submit]", form);
    var errorEl = qs("[data-form-error]", form);
    if (errorEl) errorEl.textContent = "";
    if (submitBtn) submitBtn.classList.add("is-loading");
    var formData = new FormData(form);
    CartAPI.add(formData)
      .then(function () {
        if (submitBtn) submitBtn.classList.remove("is-loading");
        var cartType = body.dataset.cartType || "drawer";
        if (cartType === "page") {
          window.location.href = "/cart";
          return;
        }
        refreshCartDrawer();
        if (cartType === "drawer") {
          setTimeout(function () {
            var d = qs(".cart-drawer");
            if (d) { d.classList.add("is-open"); body.style.overflow = "hidden"; }
          }, 150);
        }
      })
      .catch(function (err) {
        if (submitBtn) submitBtn.classList.remove("is-loading");
        if (errorEl) errorEl.textContent = (err && err.description) || "Could not add item to cart.";
      });
  });

  /* ---------------- Cart page qty/remove (non-AJAX drawer fallback) ---------------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-cart-page-qty]");
    if (btn) {
      var line = parseInt(btn.dataset.line, 10);
      var delta = parseInt(btn.dataset.cartPageQty, 10);
      var input = qs('[data-cart-page-qty-input="' + line + '"]');
      var newQty = Math.max(0, parseInt(input.value, 10) + delta);
      CartAPI.change(line, newQty).then(function () { window.location.reload(); });
    }
    var removeBtn = e.target.closest("[data-cart-page-remove]");
    if (removeBtn) {
      e.preventDefault();
      CartAPI.change(parseInt(removeBtn.dataset.cartPageRemove, 10), 0).then(function () { window.location.reload(); });
    }
  });

  var cartNoteField = qs("[data-cart-note]");
  if (cartNoteField) {
    var noteTimer;
    cartNoteField.addEventListener("input", function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () { CartAPI.updateNote(cartNoteField.value); }, 600);
    });
  }

  /* ---------------- Quantity selectors (generic) ---------------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-qty-btn]");
    if (!btn) return;
    var wrapper = btn.closest(".quantity-selector");
    var input = qs("input", wrapper);
    var step = parseInt(btn.dataset.qtyBtn, 10);
    var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
    input.value = val;
    input.dispatchEvent(new Event("change"));
  });

  /* ---------------- Accordion ---------------- */
  qsa(".accordion__trigger").forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      var item = trigger.closest(".accordion__item");
      var panel = qs(".accordion__panel", item);
      var isOpen = item.classList.contains("is-open");
      qsa(".accordion__item", trigger.closest(".accordion")).forEach(function (i) {
        i.classList.remove("is-open");
        qs(".accordion__panel", i).style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add("is-open");
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });

  /* ---------------- Product gallery ---------------- */
  qsa("[data-product-gallery]").forEach(function (gallery) {
    var thumbs = qsa(".product-gallery__thumb", gallery);
    var slides = qsa(".product-gallery__slide", gallery);
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var idx = thumb.dataset.index;
        thumbs.forEach(function (t) { t.classList.remove("is-active"); });
        slides.forEach(function (s) { s.classList.remove("is-active"); });
        thumb.classList.add("is-active");
        var slide = gallery.querySelector('.product-gallery__slide[data-index="' + idx + '"]');
        if (slide) slide.classList.add("is-active");
      });
    });
  });

  /* ---------------- Variant selection ---------------- */
  qsa("[data-product-form]").forEach(function (form) {
    var variantDataEl = qs("[data-variant-json]", form);
    if (!variantDataEl) return;
    var variants;
    try { variants = JSON.parse(variantDataEl.textContent); } catch (e) { variants = []; }
    var optionInputs = qsa("[data-option-index]", form);
    var priceEl = qs("[data-price]", form);
    var comparePriceEl = qs("[data-compare-price]", form);
    var submitBtn = qs("[data-atc-button]", form);
    var idInput = qs("[name=id]", form);
    var moneyFormat = form.dataset.moneyFormat || "${{amount}}";
    var galleryEl = document.querySelector("[data-product-gallery]");

    function getSelected() {
      var opts = [];
      optionInputs.forEach(function (group) {
        var checked = group.querySelector("input:checked, select");
        if (checked) opts.push(checked.tagName === "SELECT" ? checked.value : checked.value);
      });
      return opts;
    }
    function findVariant() {
      var selected = getSelected();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }
    function updateAvailability() {
      var selected = getSelected();
      optionInputs.forEach(function (group, groupIndex) {
        qsa("input, option", group).forEach(function (input) {
          if (input.tagName === "OPTION" && !input.value) return;
          var testSelection = selected.slice();
          testSelection[groupIndex] = input.value;
          var match = variants.find(function (v) {
            return v.options.every(function (opt, i) { return opt === testSelection[i]; });
          });
          var isAvailable = match ? match.available : false;
          var label = input.closest(".pill") || input;
          if (label.classList) label.classList.toggle("is-unavailable", !match ? false : !isAvailable);
        });
      });
    }
    function render() {
      var variant = findVariant();
      updateAvailability();
      if (!variant) {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.querySelector("[data-atc-label]").textContent = "Unavailable"; }
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.querySelector("[data-atc-label]").textContent = variant.available ? (submitBtn.dataset.addLabel || "Add to Cart") : "Sold Out";
      }
      if (variant.featured_media && galleryEl) {
        var slide = galleryEl.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (slide) {
          qsa(".product-gallery__slide", galleryEl).forEach(function (s) { s.classList.remove("is-active"); });
          qsa(".product-gallery__thumb", galleryEl).forEach(function (t) { t.classList.remove("is-active"); });
          slide.classList.add("is-active");
          var thumb = galleryEl.querySelector('.product-gallery__thumb[data-media-id="' + variant.featured_media.id + '"]');
          if (thumb) thumb.classList.add("is-active");
        }
      }
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url);
    }
    optionInputs.forEach(function (group) {
      group.addEventListener("change", function (e) {
        if (e.target.closest(".pill")) {
          qsa(".pill", group).forEach(function (p) { p.classList.remove("is-selected"); });
          e.target.closest(".pill").classList.add("is-selected");
        }
        render();
      });
      qsa(".pill", group).forEach(function (pill) {
        pill.addEventListener("click", function () {
          var input = qs("input", pill);
          if (input) { input.checked = true; input.dispatchEvent(new Event("change", { bubbles: true })); }
        });
      });
    });
    render();
  });

  /* ---------------- Sticky mobile ATC visibility ---------------- */
  var stickyAtc = qs(".sticky-atc");
  var mainAtc = qs("[data-atc-button]");
  if (stickyAtc && mainAtc && "IntersectionObserver" in window) {
    var atcObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle("is-visible", !entry.isIntersecting);
      });
    }, { threshold: 0 });
    atcObserver.observe(mainAtc);
    var stickyForwardBtn = qs("[data-sticky-atc-submit]", stickyAtc);
    if (stickyForwardBtn) {
      stickyForwardBtn.addEventListener("click", function () { mainAtc.click(); });
    }
  }

  /* ---------------- Predictive search ---------------- */
  var predictiveInput = qs("[data-predictive-search-input]");
  if (predictiveInput) {
    var resultsEl = qs("[data-predictive-search-results]");
    var timer;
    predictiveInput.addEventListener("input", function () {
      clearTimeout(timer);
      var term = predictiveInput.value.trim();
      if (term.length < 2) { resultsEl.innerHTML = ""; return; }
      timer = setTimeout(function () {
        fetch("/search/suggest.json?q=" + encodeURIComponent(term) + "&resources[type]=product,collection,page,article&resources[limit]=6")
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources.results.products || []);
            if (!products.length) {
              resultsEl.innerHTML = '<p class="search-predictive-empty">No results for "' + term + '"</p>';
              return;
            }
            resultsEl.innerHTML = products.map(function (p) {
              return '<a class="search-predictive-item" href="' + p.url + '">' +
                (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : "") +
                '<span>' + p.title + '</span></a>';
            }).join("");
          })
          .catch(function () {});
      }, 250);
    });
  }

  /* ---------------- Newsletter / wholesale / contact form success states ---------------- */
  qsa("form[data-ajax-form]").forEach(function (form) {
    // Shopify native form posting handles most cases server-side via ?form_type; nothing else needed.
  });
})();
